<template>
  <div class="container">
    <div
      v-for="(module, index) in modules"
      :key="index"
      class="card no-gutters "
    >
      <div class="row justify-content-center input-container">
        <div class="d-flex align-items-center">
          <div
            class="flex-grow-1"
            style="margin-right: 25px;"
          >
<!--            <h2><strong> teste</strong></h2>-->
          </div>
        </div>
      </div>
      <button
        class="collapsible"
        data-bs-toggle="collapse"
        :data-bs-target="`#collapse_${index}`"
        :aria-expanded="index === 0 ? 'true' : 'false'"
        :aria-controls="`collapse_${index}`"
      />
      <div
        v-for="(content, contentIndex) in module.conteudo"
        :id="`collapse_${index}`"
        :key="contentIndex"
        :class="{ show: index === 0 }"
        class="content"
        :style="{ maxHeight: module.isModuleCollapsed ? '0' : '100%' }"
      >
        <p />
        <div
          class="row justify-content-center input-container"
        >
          <div class="d-flex align-items-center">
            <div class="form-check-inline">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  class="form-check-input"
                  value=""
                >
              </label>
            </div>
            <div class="flex-grow-1">
              <h4>teste</h4>
            </div>
          </div>
        </div>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { BBadge, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BBadge,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isCollapsed: true,
      contentName: '',
      modules: [
        {
          id: 32,
          modulo_name: 'vsl Booster',
          modulo_ativo: 1,
          conteudo: [
            {
              id: 12,
              titulo: 'Como usar o Vsl-Booster',
              content: '<p>teste vsl-booster</p>',
              modulo_id: '32',
            },
            {
              id: 14,
              titulo: 'Aprenda a editar seus videos',
              content: '<p>teste</p>',
              modulo_id: '32',
            },
          ],
        },
        {
          id: 33,
          modulo_name: 'Chat',
          modulo_ativo: 1,
          conteudo: [
            {
              id: 13,
              titulo: 'Como usar o chat ',
              content: '<p>teste</p>',
              modulo_id: '33',
            },
          ],
        },
      ],
    }
  },

  mounted() {
    feather.replace()
  },

}
</script>

<style scoped>

.collapsible {
  background-color: #ffffff;
  color: #4b5563;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 17px;
  position: relative;
}

.active, .collapsible:hover {
  background-color: #eef0f1;
}

.collapsible:before {
  content: "\23F7";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.active:before {
  content: "\23F6";
}

.content {
  margin-top: -1px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  background-color: #ffffff;
  border-top: 1px solid #ccc;
  margin-left: 0px;
}
.active, .content:hover {
  background-color: #f5f5f5;
}
.content i {
  margin-right: 8px;
}

.row {
  --bs-gutter-x: -2.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-.5 * var(--bs-gutter-x));
  margin-left: calc(-.5 * var(--bs-gutter-x));
}
.input-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.input-row i {
  margin-right: 10px;
}

.w-full {
  width: 90%;
}
.border-b {
  border-bottom-width: 1px;
}

.input-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.input-container i {
  margin-right: 10px;
}

.input-container .form-control {
  margin-left: 5px;
}
.no-outline:focus {
  outline: none;
  box-shadow: none;
}

/*card*/
.card {
  max-width: 800px;
}
</style>
